export const CErrorSendMoneyContext = {
    LINK_BANK_ACCOUNT: 'LINK_BANK_ACCOUNT',
    FUND:'FUND',
    CHECKOUT: 'CHECKOUT'
} as const;